export default function(value) {
  const regexp = /\[(.*?)]\s*\((http):\/\/(\S+\.\S+)\)/g;

  return !regexp.test(String(value));
}
